(function () {
  const mmFollowEverywhereInstances = new WeakMap();
  const mmFollowBreakpoint = window.matchMedia("(max-width: 749px)");

  class MMFollowEverywhere {
    constructor(section) {
      this.section = section;
      this.carousel = section.querySelector("[data-mm-follow-everywhere-swiper]");
      this.socialCount = Number(section.dataset.mmSocialCount || 0);
      this.speed = Number(section.dataset.mmCarouselSpeed || 400);
      this.swiper = null;
      this.isMobile = mmFollowBreakpoint.matches;
      this.onBreakpointChange = this.handleBreakpointChange.bind(this);

      this.init();
    }

    init() {
      this.addBreakpointListener();
      this.updateMode();
    }

    destroy() {
      this.removeBreakpointListener();
      this.destroySwiper();
    }

    addBreakpointListener() {
      if (typeof mmFollowBreakpoint.addEventListener === "function") {
        mmFollowBreakpoint.addEventListener("change", this.onBreakpointChange);
        return;
      }

      if (typeof mmFollowBreakpoint.addListener === "function") {
        mmFollowBreakpoint.addListener(this.onBreakpointChange);
      }
    }

    removeBreakpointListener() {
      if (typeof mmFollowBreakpoint.removeEventListener === "function") {
        mmFollowBreakpoint.removeEventListener("change", this.onBreakpointChange);
        return;
      }

      if (typeof mmFollowBreakpoint.removeListener === "function") {
        mmFollowBreakpoint.removeListener(this.onBreakpointChange);
      }
    }

    handleBreakpointChange(event) {
      this.isMobile = event.matches;
      this.updateMode();
    }

    updateMode() {
      if (!this.carousel || this.socialCount < 1) {
        this.destroySwiper();
        return;
      }

      const shouldUseSwiper = this.isMobile ? this.socialCount > 1 : this.socialCount > 4;

      if (!shouldUseSwiper) {
        this.destroySwiper();
        return;
      }

      this.initSwiper();
    }

    initSwiper() {
      if (this.swiper || typeof window.Swiper !== "function") return;

      const styles = window.getComputedStyle(this.section);
      const desktopGap = parseFloat(styles.getPropertyValue("--mm-follow-social-gap")) || 26;
      const mobileGap = parseFloat(styles.getPropertyValue("--mm-follow-social-gap-mobile")) || 22;

      this.section.classList.add("is-mm-follow-swiper-active");

      this.swiper = new window.Swiper(this.carousel, {
        slidesPerView: this.isMobile ? 1.4 : 4.5,
        centeredSlides: this.isMobile,
        spaceBetween: this.isMobile ? mobileGap : desktopGap,
        speed: this.speed,
        watchOverflow: true,
      });
    }

    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      this.section.classList.remove("is-mm-follow-swiper-active");
    }
  }

  function initMMFollowEverywhere(container = document) {
    container.querySelectorAll("[data-mm-follow-everywhere-section]").forEach((section) => {
      if (mmFollowEverywhereInstances.has(section)) return;
      mmFollowEverywhereInstances.set(section, new MMFollowEverywhere(section));
    });
  }

  function unloadMMFollowEverywhere(section) {
    const instance = mmFollowEverywhereInstances.get(section);
    if (!instance) return;

    instance.destroy();
    mmFollowEverywhereInstances.delete(section);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initMMFollowEverywhere());
  } else {
    initMMFollowEverywhere();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initMMFollowEverywhere(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll("[data-mm-follow-everywhere-section]").forEach((section) => {
      unloadMMFollowEverywhere(section);
    });
  });
})();
